import React from 'react'
import {
    Card,
    Grid,
    ListItemIcon,
    ListItemText,
    MenuItem,
    MenuList,
    useTheme,
} from '@mui/material'
import { Product, products } from './Products'
import ExternSurface from '../components/ExternSurface'
import { translate } from '@focaltec-suite/core'
import { CustomAvatar } from '@focaltec-suite/commons'

interface ProductSelectionProps {
    onSelect(product: Product): void
}

export default function ProductSelection({ onSelect }: ProductSelectionProps) {
    const theme = useTheme()
    return (
        <Grid
            id="extern-app"
            container
            justifyContent="center"
            alignItems="center"
            style={{ minHeight: '100vh' }}
        >
            <ExternSurface
                title={translate('product_selection.header') as string}
                description={
                    translate('product_selection.description') as string
                }
            >
                <Grid
                    container
                    id="products-container"
                    spacing={2}
                    justifyContent="center"
                >
                    <Grid item xs={12} md={10}>
                        <Card
                            variant="outlined"
                            sx={(theme) => ({
                                backgroundColor:
                                    theme.palette.mode === 'dark'
                                        ? theme.palette.grey[800]
                                        : theme.palette.grey[100],
                            })}
                        >
                            <MenuList id="apps-menu" variant="menu">
                                {products.map((product) => (
                                    <MenuItem
                                        key={product.id}
                                        onClick={() => onSelect(product)}
                                    >
                                        <ListItemIcon>
                                            <CustomAvatar
                                                name={product.imageAlt()}
                                                color={
                                                    theme.palette.secondary.main
                                                }
                                            />
                                        </ListItemIcon>
                                        <ListItemText>
                                            {product.imageAlt()}
                                        </ListItemText>
                                    </MenuItem>
                                ))}
                            </MenuList>
                        </Card>
                    </Grid>
                </Grid>
            </ExternSurface>
        </Grid>
    )
}
